import React, { useMemo } from 'react';

import { FlexBoxRow as Row } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';

import * as ST from './styled';


export interface IBenefit {
    id: number | string,
    isLandscape: boolean,
    image: string,
    image_webp: string,
    title: string,
    text: string,
    alt: string,
}

interface IProps {
    items: IBenefit[],
    className?: string,
    showCarousel?: boolean,
}

const Benefits: React.FC<IProps> = ({ items = [], className = '', showCarousel }): JSX.Element => {
    const noLandscapeItems = useMemo(() => {
        return items.map((item: IBenefit) => {
            const newItem = { ...item };
            if (newItem.isLandscape) {
                newItem.image = newItem.image.replace(/([0-9]+)-[a-zA-Z]+\.([a-zA-Z]+)/, '$1.$2');
                newItem.image_webp = newItem.image_webp.replace(/([0-9]+)-[a-zA-Z]+\.([a-zA-Z]+)/, '$1.$2');
            }
            return newItem;
        });
    }, [items]);

    return (
        <ST.Wrapper className={className}>
            <ST.BenefitsContainer>
                {
                    !showCarousel
                        ? <Row>
                            {
                                items?.map((item) => {
                                    return (
                                        <ST.SCol
                                            key={item.id}
                                            lg={item.isLandscape ? 6 : 4}
                                            md={item.isLandscape ? 6 : 4}
                                        >
                                            <ST.BenefitItem
                                                key={item.id}
                                                isLandscape={item.isLandscape}
                                                data-test='benefit-item'
                                            >
                                                <ST.Image
                                                    bgImage={item.image}
                                                    bgWebpImage={item.image_webp}
                                                    role='img'
                                                    aria-label={item.alt}
                                                    data-test='benefit-item-image'
                                                />
                                                <ST.Desc>
                                                    <ST.Title data-test='benefit-item-title'>{item.title}</ST.Title>
                                                    <ST.Text data-test='benefit-item-text'>{item.text}</ST.Text>
                                                </ST.Desc>
                                            </ST.BenefitItem>
                                        </ST.SCol>
                                    );
                                })
                            }
                        </Row>
                        : <AdaptiveNukaCarousel
                            desktopSlideWidth='327'
                            withoutArrows
                            cellSpacing={24}
                            slidesToScroll={'auto'}
                            customDotsStyles={ST.customDotsStyles}
                            data-test='benefits-carousel'
                        >
                            {
                                noLandscapeItems?.map((item) => {
                                    return (
                                        <ST.BenefitItem
                                            key={item.id}
                                            isSlide={true}
                                            data-test='benefit-item'
                                        >
                                            <ST.Image
                                                bgImage={item.image}
                                                bgWebpImage={item.image_webp}
                                                role='img'
                                                aria-label={item.alt}
                                                data-test='benefit-item-image'
                                            />
                                            <ST.Desc>
                                                <ST.Title data-test='benefit-item-title'>{item.title}</ST.Title>
                                                <ST.Text data-test='benefit-item-text'>{item.text}</ST.Text>
                                            </ST.Desc>
                                        </ST.BenefitItem>
                                    );
                                })
                            }
                        </AdaptiveNukaCarousel>
                }
            </ST.BenefitsContainer>
        </ST.Wrapper>
    );
};

export default Benefits;
